import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { AddPurchase,BrandBasePurchaseList } from "../../../redux/services/PurchaseService/purchase.Services";
import { ActiveSupplierList } from "../../../redux/services/SupplierService/supplier.Services";
import { ActiveProductList } from "../../../redux/services/ProductService/product.Services";
import { ActiveWhereHouseList } from "../../../redux/services/WhereHouseService/wherehouse.Services";
import { ActiveBrandList } from "../../../redux/services/BrandService/brand.Services";
import { successToast, errorToast } from "../../../Utils/toast";
import { useNavigate } from "react-router";
import { FiArrowLeft, FiCreditCard } from "react-icons/fi";
import PurchaseHeader from "./AddPurchaseComponents/PurchaseHeader";
import ProductSelector from "./AddPurchaseComponents/ProductSelector";
import ProductTable from "./AddPurchaseComponents/ProductTable";
import BillSummary from "./AddPurchaseComponents/BillSummary";
import PaymentCard from "./AddPurchaseComponents/CreatePaymentCard";
function AddPurchaseItems({ refreshData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [suppliers, setSuppliers] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [brands, setBrands] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showPayment, setShowPayment] = useState(false);

  const [formData, setFormData] = useState({
    supplier_id: "",
    warehouse_id: "",
    purchase_date: "",
    invoice_no: "",
    payment_type: "",
    payment_status: "",
    paid_amount: "",
    shipping_charge: "",
    remark: "",
    items: [],
  });

  // const [productStock, setProductStock] = useState({
  //   1: { stock: 120, box: 120 },
  //   2: { stock: 80, box: 80 },
  //   3: { stock: 60, box: 60 },
  //   4: { stock: 200, box: 200 },
  // });

  useEffect(() => {
    getSuppliers();
    getWarehouses();
    getBrands();
    setFormData(prev => ({
      ...prev,
      purchase_date: new Date().toISOString().split('T')[0],
      invoice_no: `INV-${Date.now().toString().slice(-6)}`
    }));
  }, []);

  const getSuppliers = async () => {
    try {
      const res = await ActiveSupplierList();
      if (res.success) {
        setSuppliers(res.data);
      }
    } catch (error) {
      errorToast("Supplier list not found");
    }
  };

  const getWarehouses = async () => {
    try {
      const res = await ActiveWhereHouseList();
      if (res.success) {
        setWarehouses(res.data);
      }
    } catch (error) {
      errorToast("Warehouse list not found");
    }
  };

  const getBrands = async () => {
    try {
      const res = await ActiveBrandList();
      if (res.success) {
        setBrands(res.data);
      }
    } catch (error) {
      errorToast("Brand list not found");
    }
  };

 const getProducts = async (brandId) => {
  try {
    const payload = {
      id: brandId,
    };
    const res = await BrandBasePurchaseList(payload);
    if (res.success) {
      setAllProducts(res.data);
    }
  } catch (error) {
    errorToast("Product list not found");
  }
};
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const brandOptions = brands.map(brand => ({
    value: brand.id,
    label: brand.name,
  }));
  const getProductOptions = () => {
    let products = allProducts;
      return products.map(product => {
   
      return {
        value: product.id,
        // label: product.product_name,
           label: product.name,  
        sku: product.sku || '',
        brand_id: product.brand_id,
        brand_name: product.brand_name || getBrandName(product.brand_id),
        // purchase_price: product.purchase_price || '',
              purchase_price: product.cost_price || product.price || '', 
        gst_percentage: product.gst_percentage || 18,
        // available_stock: stock.stock || 0,
        // available_box: stock.box || 0,
      };
    });
  };
  const getBrandName = (brandId) => {
    const brand = brands.find(b => b.id === brandId);
    return brand ? brand.name : '';
  };
  const handleAddProduct = () => {
    console.log("Selected Product", selectedProduct);
    if (!selectedProduct) {
      return;
    }
    const existingItem = formData.items.find(
      item => item.product_id === selectedProduct.value
    );
    if (existingItem) {
      errorToast("Product already added");
      return;
    }

    setFormData({
      ...formData,
      items: [
        ...formData.items,
        {
          brand_id: selectedProduct.brand_id,
          brand_name: selectedProduct.brand_name || getBrandName(selectedProduct.brand_id),
          product_id: selectedProduct.value,
          product_name: selectedProduct.label,
          sku: selectedProduct.sku || "",
          quantity: 1,
          purchase_price: selectedProduct.purchase_price || "",
          gst_percentage: selectedProduct.gst_percentage || 18,
          discount: 0,
          total: 0,
          available_stock: selectedProduct.available_stock || 0,
          available_box: selectedProduct.available_box || 0,
        },
      ],
    });

    setSelectedProduct(null);
    successToast("Product added successfully");
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };

    const qty = parseFloat(updatedItems[index].quantity) || 0;
    const price = parseFloat(updatedItems[index].purchase_price) || 0;
    const gst = parseFloat(updatedItems[index].gst_percentage) || 0;
    const discount = parseFloat(updatedItems[index].discount) || 0;

    const subtotal = qty * price;
    const gstAmount = (subtotal * gst) / 100;
    const discountAmount = (subtotal * discount) / 100;
    updatedItems[index].total = subtotal + gstAmount - discountAmount;

    setFormData({
      ...formData,
      items: updatedItems,
    });
  };

  const removeItemRow = (index) => {
    if (formData.items.length > 0) {
      const updatedItems = formData.items.filter((_, i) => i !== index);
      setFormData({
        ...formData,
        items: updatedItems,
      });
    }
  };

  const calculateGrandTotal = () => {
    return formData.items.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.supplier_id) {
      newErrors.supplier_id = ["Supplier is required"];
    }
    if (!formData.purchase_date) {
      newErrors.purchase_date = ["Purchase date is required"];
    }
    if (formData.items.length === 0) {
      newErrors.items = ["At least one product is required"];
    }

    formData.items.forEach((item, index) => {
      if (!item.product_id) {
        newErrors[`items.${index}.product_id`] = ["Product is required"];
      }
      if (!item.quantity || parseFloat(item.quantity) <= 0) {
        newErrors[`items.${index}.quantity`] = ["Valid quantity is required"];
      }
      if (!item.purchase_price || parseFloat(item.purchase_price) <= 0) {
        newErrors[`items.${index}.purchase_price`] = ["Valid purchase price is required"];
      }
    });

    setErrors(newErrors);
    return newErrors;
  };

  const togglePayment = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }
    setShowPayment(!showPayment);
  };
const handleBrandChange = async (brand) => {
  setSelectedBrand(brand);
  setSelectedProduct(null);
  if (!brand) {
    setAllProducts([]);
    return;
  }
  await getProducts(brand.value);
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        grand_total: calculateGrandTotal(),
      };
      const res = await AddPurchase(payload);
      if (res?.success === true) {
        successToast(res.message);
        setFormData({
          supplier_id: "",
          warehouse_id: "",
          purchase_date: new Date().toISOString().split('T')[0],
          invoice_no: `INV-${Date.now().toString().slice(-6)}`,
          payment_type: "cash",
          payment_status: "paid",
          paid_amount: "",
          shipping_charge: "",
          remark: "",
          items: [],
        });
        setErrors({});
        // setShowPayment(false);
        refreshData?.();
        dispatch(refreshProductList());
        // dispatch(closeProductModal());
      navigate("/purchase-list")
      } else {
        if (res?.errors) {
          setErrors(res.errors);
        } else {
          errorToast(res?.message || "Failed to create purchase");
        }
      }
    } catch (error) {
      console.error("Error creating purchase:", error);

      if (error?.response?.status === 422) {
        const apiErrors = error.response.data?.errors || {};
        setErrors(apiErrors);
      } else {
        errorToast(error?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main_page">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0 fw-bold">Add Purchase</h4>
            <button
            type="button"
              className="btn btn-primary btn-sm"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Purchase Header */}
            <PurchaseHeader
              formData={formData}
              handleInputChange={handleInputChange}
              suppliers={suppliers}
              warehouses={warehouses}
              errors={errors}
            />

            {/* Product Selector */}
        <ProductSelector
  brandOptions={brandOptions}
  productOptions={getProductOptions()}
  selectedBrand={selectedBrand}
  selectedProduct={selectedProduct}
  setSelectedBrand={handleBrandChange}
  setSelectedProduct={setSelectedProduct}
  handleAddProduct={handleAddProduct}
/>

            {/* Product Table */}
            <div className="mt-3">
              <ProductTable
                products={formData.items}
                handleDeleteProduct={removeItemRow}
                handleProductChange={handleItemChange}
              />
            </div>

       
            {/* Payment Toggle Button */}
            {formData.items.length > 0 && (

              <div className="row mt-4">

                <div className="col-md-12">

                  <BillSummary
                    products={formData.items}
                    shippingCharge={formData.shipping_charge || 0}
                    otherCharge={0}
                    roundOff={0}
                  />

                </div>

              </div>

            )}

            {/* Payment Card - Toggleable */}
            {formData.items.length > 0 && showPayment && (

              <div className="mt-3">

                <PaymentCard
                  formData={formData}
                  handleInputChange={handleInputChange}
                  grandTotal={calculateGrandTotal()}
                />

              </div>

            )}

            {/* Action Buttons */}
            <div className="d-flex justify-content-end gap-2 pt-3 border-top mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || formData.items.length === 0}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Creating...
                  </>
                ) : (
                  "Add Purchase"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddPurchaseItems;